import React from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { SelectOption } from '@Components/Selectors/Select'
import {
    akaTitleInvalidCheck,
    akaTitleTypeInvalidCheck,
    languageInvalidCheck,
} from '@App/helpers/work-entities/fields-validators'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'
import { StoresContext } from '@App/contexts'
import { AlternativeTitleModel } from '@Entities/work/alternative-title-model'
import clsx from 'clsx'

interface IProps {
    data: AlternativeTitleModel
    editFunc?(): void
    removeFunc?(removingTitle: AlternativeTitleModel): void
}

const AlternativeTitleCard = ({ data, editFunc, removeFunc }: IProps) => {
    const { libStore } = React.useContext(StoresContext)
    const type = React.useMemo(() => {
        const typeCode = data.titleType
        if (typeCode) {
            const findType = libStore.akaTitleTypes.filter((option: SelectOption) => {
                if (+option.id !== typeCode) {
                    return
                }
                return option
            })

            return findType.length > 0 && 'label' in findType[0] ? findType[0].label : ''
        } else {
            return ''
        }
    }, [libStore.akaTitleTypes, data.titleType])
    const langLabel = React.useMemo(() => {
        const langCode = data.languageCode
        if (langCode) {
            const findLanguage = libStore.languages.filter((option: SelectOption) => {
                if (+option.id !== langCode) {
                    return
                }
                return option
            })

            return findLanguage.length > 0 && 'label' in findLanguage[0] ? findLanguage[0].label : ''
        } else {
            return ''
        }
    }, [libStore.languages, data.languageCode])

    const akaTitle = data.title
    const akaTitleType = data.titleType
    const langCode = data.languageCode
    const akaTypeOptions = libStore.akaTitleTypes
    const langOptions = libStore.languages

    return (
        <div className="alternative-title-card">
            <div className="head">
                <p className={clsx('bold', akaTitleInvalidCheck(akaTitle) && 'red-text')}>
                    {akaTitle ? stringEscapeNewlines(akaTitle) : ''}
                </p>
                <div className="controls">
                    {editFunc ? (
                        <span className="medium" onClick={editFunc}>
                            Edit
                        </span>
                    ) : null}
                    {removeFunc ? (
                        <span className="medium" onClick={() => removeFunc(data)}>
                            Remove
                        </span>
                    ) : null}
                </div>
            </div>
            <div className="content">
                <p className="small">
                    <span className={clsx(akaTitleTypeInvalidCheck(akaTitleType, akaTypeOptions) && 'red-text bold')}>
                        Alternative title type:{' '}
                    </span>
                    <strong>{type}</strong>
                </p>
                <p className="small">
                    <span className={clsx(languageInvalidCheck(langCode, langOptions, false) && 'red-text bold')}>
                        Language:{' '}
                    </span>
                    <strong>{langLabel}</strong>
                </p>
            </div>
        </div>
    )
}

export default observer(AlternativeTitleCard)
